import removeAlertMessage from './remove-alert-message'

export default removeAlertMessage
